import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NavMenuService } from '../../../core/components/navmenu/navmenu.service';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { EnumIdsTwTcTipoClonacion, EnumCodigosTwTcAcciones } from '../../../_importacion/solicitudes/types/enum';
import { SolicitudExService } from '../datosbasicos/datosbasicosEx.service';
import { ReexportacionService } from './reexportacion.service';
import { SolicitudReexportacionViewModel, TReexportacionViewModel } from './reexportacion.types';
import { TcPerfilUsuarioEnum } from '../../../core/_infrastructure/types/common';
import { EnumIdsTwTcSubTipoSolicitudEx } from '../types/enum';

@Component({
    selector: 'app-reexportacion-edit',
    templateUrl: './reexportacion-edit.component.html',
})
export class ReexportacionEditComponent extends ComponentBase implements OnInit {
    solicitudReexportacion: SolicitudReexportacionViewModel;
    reexportacion: TReexportacionViewModel;
    idSolicitudEx = 0;

    tercerPaisConAtestFito = EnumIdsTwTcSubTipoSolicitudEx.ID_TERCER_PAIS_CON_ATEST_FITO;
    reExpConAtestFito = EnumIdsTwTcSubTipoSolicitudEx.ID_REEXPORTACION_CON_ATEST_FITO;
    canariasConAtestFito = EnumIdsTwTcSubTipoSolicitudEx.ID_CANARIAS_CON_ATEST_FITO;

    visibilitySpinner = false;

    private activatedRoute$ = this.activatedRoute.paramMap.subscribe(params => {
        const id: any = params.get('id');
        if (id) {
            this.loadSolicitud(id);
        }
    });

    constructor(
        private cd: ChangeDetectorRef,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private fb: UntypedFormBuilder,
        private solicitudExService: SolicitudExService,
        private navMenuService: NavMenuService,
        private reexportacionService: ReexportacionService,
        protected authService: AuthService,
        protected notificacionService: NotificationService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificacionService, exceptionHandler);
        this.solicitudReexportacion = new SolicitudReexportacionViewModel();
    }

    ngOnInit() {
        this.createForm();
    }

    private loadSolicitud(id: number): void {
        this.idSolicitudEx = id;

        this.guardRefreshPage(this.idSolicitudEx);

        if (this.idSolicitudEx) {
            this.loading = true;

            this.reexportacionService.getSolicitudReexportacion(this.idSolicitudEx).subscribe(result => {
                this.solicitudReexportacion = result;

                ////SI ES PREVIA
                //if (this.solicitudPreviaInspectorEx.EsPrevia) {
                //    if (this.solicitudPreviaInspectorEx.IdEstadoSolicitudEx != EnumIdsTcEstadoSolicitud.ID_PREVIA_ACEPTADA &&
                //        this.solicitudPreviaInspectorEx.IdEstadoSolicitudEx != EnumIdsTcEstadoSolicitud.ID_PREVIA_PENDIENTE) {
                //        this.tituloTipoSolicitudEx += "-Previa";
                //    }
                //}

                if (!this.esNuevaReexportacion) {
                    this.updateForm();
                }

                if (this.habilitarGuardar) {
                    if (!this.esInspector) {
                        this.form.controls['NumCertificadoReex'].enable();
                        this.form.controls['Original'].enable();
                        //this.form.controls["CopiaFielCertificada"].enable();
                        this.form.controls['Empacados'].enable();
                        //this.form.controls["Reempacados"].enable();
                        this.form.controls['EnvaseOriginal'].enable();
                        //this.form.controls["EnvaseNuevo"].enable();
                    } else {
                        this.form.controls['CertFitoOriginal'].enable();
                        this.form.controls['InspAdicional'].enable();
                    }
                }

                this.loading = false;
            });
        }
    }

    private guardRefreshPage(id: number): void {
        if ((id && !this.navMenuService.currentSolicitudExportacion.Id) || this.navMenuService.currentSolicitudExportacion.Id !== id) {
            this.solicitudExService.getSolicitudEx(id).subscribe(result => {
                this.navMenuService.currentSolicitudExportacion = result;
            });
        }
    }

    createForm(): void {
        this.form = this.fb.group({
            IdSolicitud: this.navMenuService.currentSolicitudImportacion.Id,
            NumCertificadoReex: [{ value: '', disabled: true }, Validators.compose([Validators.required, Validators.minLength(1)])],
            Original: [{ value: '', disabled: true }, Validators.required],
            //CopiaFielCertificada: [{ value: '', disabled: true }],
            Empacados: [{ value: '', disabled: true }, Validators.required],
            //Reempacados: [{ value: '', disabled: true }],
            EnvaseOriginal: [{ value: '', disabled: true }, Validators.required],
            //EnvaseNuevo: [{ value: '', disabled: true }],
            CertFitoOriginal: [{ value: false, disabled: true }],
            InspAdicional: [{ value: false, disabled: true }],
        });
    }

    private updateForm(): void {
        this.form.setValue({
            IdSolicitud: this.solicitudReexportacion.Id,
            NumCertificadoReex: this.solicitudReexportacion.TReexportacion.NumCertificadoReex,
            Original: this.solicitudReexportacion.TReexportacion.Original ? 'S' : 'N',
            //CopiaFielCertificada: this.solicitudReexportacion.TReexportacion.CopiaFielCertificada ? 'S' : 'N',
            Empacados: this.solicitudReexportacion.TReexportacion.Empacados ? 'S' : 'N',
            //Reempacados: this.solicitudReexportacion.TReexportacion.Reempacados ? 'S' : 'N',
            EnvaseOriginal: this.solicitudReexportacion.TReexportacion.EnvaseOriginal ? 'S' : 'N',
            //EnvaseNuevo: this.solicitudReexportacion.TReexportacion.EnvaseNuevo ? 'S' : 'N',
            CertFitoOriginal: this.solicitudReexportacion.TReexportacion.CertFitoOriginal,
            InspAdicional: this.solicitudReexportacion.TReexportacion.InspAdicional,
        });
    }

    onBack(): void {
        this.router.navigate(['/exportacion/solicitud/datosbasicosEx', this.navMenuService.currentSolicitudExportacion.Id]);
    }

    onSubmit(): void {
        this.submitted = true;

        if (this.certificadoOInsAdicionalRequired) {
            this.addErrorMessage('Debe seleccionar al menos una opción del punto 3');
            this.addValidator('CertFitoOriginal', Validators.requiredTrue);
            this.cd.detectChanges();
            return;
        }
        this.removeValidators('CertFitoOriginal');

        if (!this.form.valid) {
            this.addErrorMessage('Revise los datos');
            return;
        }

        let reexportacion = new TReexportacionViewModel();
        //así­ viajan todos los values, da igual si están disable o no los campos
        //reexportacion = this.form.getRawValue();
        reexportacion.IdSolicitudEx = this.idSolicitudEx;

        if (this.esInspector) {
            reexportacion.NumCertificadoReex = this.solicitudReexportacion.TReexportacion.NumCertificadoReex;
            reexportacion.Original = this.solicitudReexportacion.TReexportacion.Original;
            reexportacion.CopiaFielCertificada = this.solicitudReexportacion.TReexportacion.CopiaFielCertificada;
            reexportacion.Empacados = this.solicitudReexportacion.TReexportacion.Empacados;
            reexportacion.Reempacados = this.solicitudReexportacion.TReexportacion.Reempacados;
            reexportacion.EnvaseOriginal = this.solicitudReexportacion.TReexportacion.EnvaseOriginal;
            reexportacion.EnvaseNuevo = this.solicitudReexportacion.TReexportacion.EnvaseNuevo;

            reexportacion.CertFitoOriginal = this.form.value.CertFitoOriginal;
            reexportacion.InspAdicional = this.form.value.InspAdicional;
        } else {
            reexportacion.NumCertificadoReex = this.form.value.NumCertificadoReex;
            reexportacion.Original = this.form.value.Original == 'S' ? true : false;
            reexportacion.CopiaFielCertificada = this.form.value.Original == 'N' ? true : false;
            reexportacion.Empacados = this.form.value.Empacados == 'S' ? true : false;
            reexportacion.Reempacados = this.form.value.Empacados == 'N' ? true : false;
            reexportacion.EnvaseOriginal = this.form.value.EnvaseOriginal == 'S' ? true : false;
            reexportacion.EnvaseNuevo = this.form.value.EnvaseOriginal == 'N' ? true : false;
        }

        this.visibilitySpinner = true;

        if (this.esNuevaReexportacion) {
            this.reexportacionService.createReexportacion(reexportacion).subscribe({
                next: () => {
                    this.addSuccessMessage('Datos guardados correctamente');
                    //this.onBack();
                    this.visibilitySpinner = false;
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                },
            });
        } else {
            this.reexportacionService.editReexportacion(reexportacion).subscribe({
                next: () => {
                    this.addSuccessMessage('Datos modificados correctamente');
                    //this.onBack();
                    this.visibilitySpinner = false;
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                },
            });
        }
    }

    get esInspector(): boolean {
        return this.isInspector;
    }

    get habilitarGuardar(): boolean {
        return this.loggedInUser!.getAction(
            EnumCodigosTwTcAcciones.MENU_REEXPORTACION,
            this.solicitudReexportacion.IdEstadoSolicitudEx,
            this.solicitudReexportacion.IdTipoSolicitudEx,
        ).Editable;
    }

    get esNuevaReexportacion(): boolean {
        return this.solicitudReexportacion.TReexportacion == null;
    }

    get esClonada(): boolean {
        return (
            this.solicitudReexportacion.TwSolicitudJerarquiaEx != null &&
            this.solicitudReexportacion.TwSolicitudJerarquiaEx.IdTipoClonacion == EnumIdsTwTcTipoClonacion.ID_CLONACION
        );
    }

    get certificadoOInsAdicionalRequired(): boolean {
        return this.esInspector && !this.form.value.CertFitoOriginal && !this.form.value.InspAdicional;
    }
}
